import { fromJS, Map } from 'immutable';
import Contact from '../../utils/models/Contact';
import { CONTACTS_CHANGED, WS_DATA_ATTENDANCE_MINIMUMS, WS_DATA_CONTACT, WS_DATA_CONTACTS } from '../constants/contact.constants';
import { normalizeAttendanceMinimums } from '../../utils/models/AttendanceMinimums';
import { AUTH_SUCCESS } from '../../containers/LoginPage/constants';

export const initialState = fromJS({
	fetched: false,
	data: {},
})
	// null = not loaded yet: saving before the first websocket message would PUT defaults over stored data.
	// Once loaded it is a plain frozen object, not a Record: it is replaced as a whole and mirrors the API JSON.
	.set('attendanceMinimums', null);

function reducer(state: Map = initialState, action) {
	let contacts = state.get('data');
	let minimums;
	switch(action.type) {
		case AUTH_SUCCESS:
			return initialState;
		case WS_DATA_CONTACT:
			return state.setIn(['data', action.data.id], new Contact(action.data));
		case CONTACTS_CHANGED:
			return state.set('data', action.contacts);
		case WS_DATA_CONTACTS:
			contacts = Map(action.data.map(q => new Contact(q)).map(q => [q.id, q]));
			return state
				.set('data', contacts)
				.set('fetched', true);
		case WS_DATA_ATTENDANCE_MINIMUMS:
			minimums = normalizeAttendanceMinimums(action.data);
			if (!minimums) {
				// Keep what was loaded (or stay unloaded) rather than falling back to defaults;
				// attendanceMinimums.saga reports it
				return state;
			}
			return state.set('attendanceMinimums', minimums);
		default:
			return state;
	}
}

export default reducer;
